import React, { useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";
import { useNavigate } from "react-router-dom";

import {getUserEmail, getReservationNo, Translation as T} from "@awe-web/shared/lib";
import { useInitialize } from "../../../util/react.js";
import {Row, Col} from "../../../components/grid.js";
import {ScreenSection, ScreenHeading, ScreenLoading} from "../../../components/screen.js";
import {Button} from "../../../components/form.js";
import {TypeArea} from "../../../components/layout.js";
import PickupNotice from "../../../components/pickup_notice";
import {B2B_Profile} from "../../../routing/routes.js";
import {initialize} from "./actions.js";

import "./submit_rent_contract_success.scss";

const SCREEN_TITLE = "FSD0000176";
const RESERVATION_NUMBER = "FSD0000177";
const CONFIRMATION_TEXT = "FSD0000178";
const PROFILE_BUTTON = "ALG0000117";

function InternalSubmitRentContractSuccess() {
  const reservationNo = useSelector((state) => getReservationNo(state));
  const email = useSelector((state) => getUserEmail(state));

  return (
    <ScreenSection main dark>
      <TypeArea>
        <Row>
          <Col
            desktop={{cols: 8, offset: 2}}
            className="b2b-str-submit-rent-contract-success__reservation-details"
          >
            <ScreenHeading>
              <T code={SCREEN_TITLE} />
            </ScreenHeading>

            <div className="b2b-str-submit-rent-contract-success__reservation-number">
              <div><T code={RESERVATION_NUMBER} /></div>
              <div>{reservationNo}</div>
            </div>

            <div>
              <T code={CONFIRMATION_TEXT} data={{email: <b>{email}</b>}} />
            </div>
          </Col>
        </Row>

        <Row>
          <Col
            desktop={{cols: 8, offset: 2}}
            className="b2b-str-submit-rent-contract-success__pickup-notice"
          >
            <PickupNotice reservationPath="B2B" />
          </Col>
        </Row>
      </TypeArea>
    </ScreenSection>
  );
}

export default function B2B_STR_SubmitRentContractSuccess() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

   const init = useCallback(async () => {
      const redirectPath = await dispatch(initialize());
  
      if (redirectPath && redirectPath.length > 0) {
        navigate(redirectPath);
      }
    }, [dispatch, navigate]);

  const isReady = useInitialize(init);
  if (!isReady) {
    return <ScreenLoading />;
  }

  return (
    <div className="b2b-str-submit-rent-contract-success">
      <InternalSubmitRentContractSuccess/>

      <ScreenSection>
        <TypeArea>
          <Row>
            <Col tablet={{cols: 4, offset: 2}} desktop={{cols: 4, offset: 4}}>
              <Button primary continue to={B2B_Profile.path()}>
                <T code={PROFILE_BUTTON} />
              </Button>
            </Col>
          </Row>
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
